import {
  FETCH_REVISIONS_REQUEST,
  FETCH_REVISIONS_SUCCESS,
  FETCH_REVISIONS_FAILURE,
} from '../Handlers/fetchRevisions'

const initialState = {
  data: [],
  loading: false,
  error: null,
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REVISIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case FETCH_REVISIONS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    case FETCH_REVISIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}
